export class EmployeeDesignationHistories {

  Id: number
  EmpCode: number
  DesignationId: number
  DesignationName: string
  StartDate: Date
  EndDate: Date
  CreatedBy: string;
  CreatedDate: Date;
  ModifiedBy: string;
  ModifiedDate: Date;
  IsActive: boolean;
  //to display error message for duplicate records in history tab
  hasDuplicateNameError?: boolean;
  duplicateNameMessage?: string;
}
